<div class="container-fluid pb-3" [class]="deviceDetector.isMobile() ? 'content-' + interaction?.orientation : ''">
  <div class="row">
    <div class="col-12 pt-3 interaction-header" [class]="'header-' + interaction?.onComplete.contentType">
      <h3 class="text-center  text-uppercase font-weight-bold mb-3">
        {{interaction?.onComplete.content.title}}
      </h3>
      <p class="text-center  font-italic" *ngIf="true" [innerHtml]="interaction?.onComplete.content.subtitle"></p>
    </div>
    <div class="col-12 bg-secondary">
      <app-image *ngIf="type === 'image'" [content]="content"></app-image>
      <app-video *ngIf="type === 'video'" [content]="content"></app-video>
    </div>
    <div class="col-12 mt-3 text-center">
<!--      <a href="javascript:;" class="btn btn-outline-black btn-rounded" [routerLink]="'/'"><i class="fa fa-chevron-left mr-1"></i> Torna all'indice</a>-->
      <a href="javascript:;" class="d-block mt-3 mb-3 text-medium" (click)="onReset(interaction)"><i class="fa fa-undo-alt mr-1"></i>
        <span *ngIf="language ==='it'">Gioca di nuovo</span>
        <span *ngIf="language ==='en'">Play again</span>
        <span *ngIf="language ==='fr'">Rejouer</span>
      </a>
      <p>
        <span *ngIf="language ==='it'">Oppure inquadra un altro QR code</span>
        <span *ngIf="language ==='en'">Or scan another QR code</span>
        <span *ngIf="language ==='fr'">Ou scannez un autre code QR</span>
      </p>
    </div>
  </div>
</div>
<app-orientation-alert *ngIf="deviceDetector.isMobile()" [orientation]="interaction?.orientation" [class]="'turn-to-' + interaction?.orientation"></app-orientation-alert>
